// src/store/reducers/registrationSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    userType: null, // "regular" | "company" | "hero"

    regularFormFields: {
        gender:'not defined',
        isRegular: true,
        isCompany: false,
        isHero: false,
        firstName: '',
        lastName: '',
        telephone: '',
        email: '',
        isCooperator: false,
        isProducer: false,
        isSpeculator: false,
        isTrader: false,
        isTransformer: false,
        companyWishesWhenRegistering: '',
        residenceCountry:'',
        activityCountry: '',
        ipAddress: '',
        platformSource: "",
        residenceCity: ''
    },

    companyFormFields: {
        gender:'not defined',
        isRegular: false,
        isCompany: true,
        isHero: false,
        firstName: '',
        lastName: '',
        telephone: '',
        email: '',
        isCooperative: false,
        companyName: '',
        companySector: '',
        companyAgroRealm: '',
        companyStatus: '',
        companyCode: '',
        responsabilityInCompany: '',
        isProducer: false,
        isSpeculator: false,
        isTrader: false,
        isTransformer: false,
        companyWishesWhenRegistering: '',
        residenceCountry:'',
        activityCountry: '',
        ipAddress: '',
        platformSource: "",
        residenceCity: ''
    },

    heroFormFields: {
        isRegular: false,
        isCompany: true,
        isHero: true,
        firstName: "",
        lastName: "",
        gender: "",
        telephone: "",
        email: "",
        nationality: "",
        nationalIdOrPassport: "",
        additionalAddress:"",
        companyName: "",
        companyCode: "",
        companySector: "",
        companyStatus: "",
        companyAgroRealm: "",
        responsabilityInCompany: "",
        preferredLanguage: "",
        deliveryAddress:"",
        isProducer: false,
        isSpeculator: false,
        isCooperative: false,
        isTrader: false,
        isTransformer: false,
        isImporter: false,
        isExporter: false,
        importExportType: "",

        countriesOfOperation: "",
        companyPhoneNumber: "",
        companyEmail: "",
        subscriptionPlan: "",
        wishesWhenRegistering: "",
        optInNews: false,
        importExportProof: "",
        powerOfAttorneyFile: "",

        platformSource: "",
        ipAddress: "",
        residenceCountry: "",
        residenceCity: "",
        activityCountry: ""
    },

    files: [],
};

const registrationSlice = createSlice({
    name: 'registration',
    initialState,
    reducers: {
        setUserType(state, action) {
            state.userType = action.payload; // "regular", "company", or "hero"
        },

        setFormField(state, action) {
            const { field, value } = action.payload;
            if (state.userType === 'nonCompany') {
                state.regularFormFields[field] = value;
            } else if (state.userType === 'company') {
                state.companyFormFields[field] = value;
            } else if (state.userType === 'hero') {
                state.heroFormFields[field] = value;
            }
        },

        addFiles(state, action) {
            const newFiles = action.payload;
            const combined = [...state.files, ...newFiles];
            const uniqueFiles = Array.from(new Map(combined.map(f => [f.name, f])).values());
            state.files = uniqueFiles;
        },

        removeFile(state, action) {
            const fileName = action.payload;
            state.files = state.files.filter(file => file.name !== fileName);
        },

        resetForm(state) {
            state.userType = null;
            state.regularFormFields = initialState.regularFormFields;
            state.companyFormFields = initialState.companyFormFields;
            state.heroFormFields = initialState.heroFormFields;
            state.files = [];
        },
    },
});

export const {
    setUserType,
    setFormField,
    addFiles,
    removeFile,
    resetForm
} = registrationSlice.actions;

export default registrationSlice.reducer;
